import {connect} from 'react-redux'
import {getPhotoList} from "../../../../selectors"
import Photos from './Photos.jsx'

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.params.id;
  const photos = getPhotoList(state, id);
      return {
        id,
        photos: photos ? photos.photo : [],
        title: photos ? photos.title : '',
        total: photos ? photos.total : 0
      }
};

export default connect(mapStateToProps)(Photos);



/** WEBPACK FOOTER **
 ** ./src/components/Media/Photos/Photos/Photos.js
 **/